var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOfflineDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41406 11.2284L7.99684 13.8111L10.5796 11.2284",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.99991V13.8111",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7328 11.9322C14.2942 11.5374 14.7151 10.974 14.9346 10.3238C15.1541 9.67361 15.1607 8.97037 14.9534 8.31616C14.7461 7.66195 14.3358 7.09081 13.7819 6.68562C13.228 6.28042 12.5595 6.06227 11.8732 6.0628H11.0596C10.8654 5.30597 10.5021 4.60305 9.99689 4.00697C9.49172 3.41089 8.85791 2.93717 8.14316 2.62149C7.42842 2.3058 6.65138 2.15638 5.87053 2.18446C5.08968 2.21254 4.32538 2.4174 3.63516 2.7836C2.94494 3.14981 2.34679 3.66783 1.88574 4.29866C1.42469 4.92949 1.11276 5.65669 0.97342 6.42552C0.834086 7.19435 0.870981 7.98477 1.08133 8.73728C1.29168 9.48979 1.66999 10.1848 2.1878 10.7699",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineDownload);
export default __webpack_public_path__ + "static/media/offlineDownload.a0facbdbf1b936d540a6f802ed661b91.svg";
export { ForwardRef as ReactComponent };